<template>
  <div :style="boxStyle" class="search-box-container">
    <el-icon size="14">
      <Search />
    </el-icon>

    <input v-model="inputValue" type="text" :placeholder="placeholder" @change="handleChange" />
  </div>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue';

  interface Props {
    placeholder?: string;
    width?: number;
    height?: number;
    blockWidth?: boolean;
  }

  const props = withDefaults(defineProps<Props>(), {
    placeholder: '搜索',
    width: 200,
    height: 32,
    blockWidth: false
  });

  const boxStyle = computed(() => {
    return {
      width: props.blockWidth ? '100%' : `${props.width}px`,
      height: `${props.height}px`
    };
  });

  const inputValue = ref('');

  const emit = defineEmits(['change']);

  function handleChange() {
    emit('change', inputValue.value);
  }
</script>

<style scoped>
  .search-box-container {
    box-sizing: border-box;
    padding: 0px 10px;
    display: flex;
    align-items: center;
    border-radius: 4px;
    background-color: #f8fafc;
    border: 1px solid #e5e7eb;
    gap: 6px;
    color: #94a3b8;
  }

  .search-box-container input {
    outline: 0;
    height: 100%;
    width: 0;
    flex: 1;
    box-sizing: border-box;
    background-color: transparent;
    border: 0;
    color: #374151;
    font-size: 13px;
  }

  .search-box-container input::placeholder {
    color: #9ca3af;
  }
</style>
